/**
 * Product level and feature flags (V0-01).
 *
 * Level 1 = micro-engagement. Level 2/3 features stay in the code and in the
 * simulator's "Flows archivés" toggle; they are only hidden from the menus.
 * Turn a flag on to bring a feature back, nothing has to be restored.
 */
export const PRODUCT_LEVEL = 1;

export const FEATURES = {
  availability: false, // Flow 2 step "Disponibilités" and /dispos (N2)
  weeklyPlan: false, // Flow 4 /plan (N2)
  objectivesLegacy: false, // Flow 3 /objectifs and /liste (replaced by /proposer, N1 lot 2)
  sessionsLegacy: false, // Flow 5 /debut (replaced by /commencer, N1 lot 2)
  activitiesLegacy: false, // Flow 6 legacy feedback (replaced by /realisation, N1 lot 2)
  photoHelp: false, // Flow 8 /photo, AI photo help (N3 Leia)
  agenda: false, // Flow 9 /agenda, deadline extraction (N2)
  schedule: false, // Settings > Horaire (N2)
  legacyWebSms: false, // old one-shot SMS fired from the simulator flows
  // Level 1 parts not shipped yet. The parent flow only mentions them once on.
  engagements: true, // lot 2: propose / accept an activity in the chat
  weeklyReport: true, // lot 3: weekly review + Saturday-noon email
  helpRequests: true, // lot 3: "Je bloque" help with escalation
  aiHelp: false, // lot 3: AI help in the escalation (N3, needs parent consent)
  smsAlerts: false, // lot 4: text-message alerts
};

/** Flows hidden at level 1, by simulator flow id. */
export const ARCHIVED_FLOW_IDS = [
  !FEATURES.objectivesLegacy && 3,
  !FEATURES.weeklyPlan && 4,
  !FEATURES.sessionsLegacy && 5,
  !FEATURES.activitiesLegacy && 6,
  !FEATURES.photoHelp && 8,
  !FEATURES.agenda && 9,
].filter(Boolean);

/** Commands shown in the Level 1 menu. Lot 2 wires the engagement ones. */
export const N1_MENU = [
  ["/accueil", "Accueil"],
  ["/inviter", "Inviter mon enfant", "parent"],
  ["/proposer", "Proposer un plan d’étude", "parent"],
  ["/étude", "Créer un plan d’étude", "student"],
  ["/plans", "Voir mes plans"],
  ["/commencer", "Je commence", "student"],
  ["/échéances", "Voir mes échéances", "student"],
  ["/realisation", "J’ai fait une séance", "student"],
  ["/aide", "Demandes d’aide", "parent"],
  ["/aide", "Je bloque / demande de l’aide", "student"],
  ["/suivi", "Voir le suivi des plans"],
  ["/bilan", "Bilan de la semaine"],
];

/** Commands that belong to archived flows. */
export const ARCHIVED_COMMANDS = {
  objectifs: 3,
  objectif: 3,
  liste: 3,
  "voir objectif": 3,
  3: 3,
  dispos: 2,
  disponibilite: 2,
  "disponibilité": 2,
  plan: 4,
  "voir plan": 4,
  4: 4,
  debut: 5,
  "début": 5,
  seance: 5,
  "séance": 5,
  5: 5,
  photo: 8,
  8: 8,
  agenda: 9,
  9: 9,
};

export function isArchivedFlow(flowId) {
  return ARCHIVED_FLOW_IDS.includes(flowId);
}
